import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
export function UrgencySection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-24 overflow-hidden" data-id="element-327">
      {/* Red accent glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-red/5 via-transparent to-transparent" data-id="element-328" />
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-red/50 to-transparent" data-id="element-329" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center" data-id="element-330">
        <SectionReveal data-id="element-331">
          <p className="text-4xl mb-4" data-id="element-332">⚠️</p>
          <div className="flex justify-center mb-6" data-id="element-333">
            <div className="inline-flex items-center gap-2 bg-brand-red/10 border border-brand-red/25 rounded-full px-5 py-2" data-id="element-334">
              <span className="text-brand-red font-body text-sm font-semibold uppercase tracking-wider" data-id="element-335">
                PRECIO PROMOCIONAL POR TIEMPO LIMITADO
              </span>
            </div>
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white mb-8 uppercase tracking-[-0.02em]" data-id="element-336">
            Este precio puede aumentar en cualquier momento
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-337">
          <div className="bg-brand-red/10 border-2 border-brand-red/30 rounded-xl p-6 md:p-8 mb-8 inline-block" data-id="element-338">
            <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-brand-red m-0" data-id="element-339">
              👉 seguís pagando de más.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.25} data-id="element-340">
          <p className="text-xl sm:text-2xl text-gray-400 font-body" data-id="element-341">
            Y esa plata no vuelve.
          </p>
        </SectionReveal>
      </div>
    </section>;
}